"use client";

import { useLayoutEffect, useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Plus, Minus } from "lucide-react";

const faqAnswerClassName =
  "text-mute leading-7 text-sm lg:text-base [&_ul]:list-disc [&_ul]:pr-5 [&_ul]:space-y-2 [&_li]:leading-7";

const AccordionIcons = () => (
  <div className="relative w-6 h-6 flex items-center justify-center">
    <Plus
      className="absolute transition-all duration-300 ease-in-out
        group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0 group-data-[state=open]:scale-0"
    />
    <Minus
      className="absolute transition-all duration-300 ease-in-out opacity-0 scale-0
        group-data-[state=open]:rotate-180 group-data-[state=open]:opacity-100 group-data-[state=open]:scale-100"
    />
  </div>
);

export default function FAQ({ faqs = [], children }) {
  const [interactive, setInteractive] = useState(false);

  useLayoutEffect(() => {
    setInteractive(true);
  }, []);

  if (children) {
    return (
      <section>
        <dl className="space-y-4">{children}</dl>
      </section>
    );
  }

  const faqData =
    Array.isArray(faqs) && faqs.length > 0
      ? faqs.map((faq, index) => ({
          id: faq.id?.toString() || `item-${index}`,
          question: faq.question || "",
          answer: faq.answer || "",
        }))
      : [
          {
            id: "item-1",
            question: "چطور محصول مناسب فضای خودم را انتخاب کنم؟",
            answer:
              "برای انتخاب بهتر، می‌توانید ابعاد فضا، نوع کاربری و سبک طراحی موردنظر خود را در نظر بگیرید. همچنین با استفاده از تصاویر، مشخصات محصول و قابلیت مشاهده در فضای واقعی، تصمیم‌گیری دقیق‌تری خواهید داشت.",
          },
          {
            id: "item-2",
            question: "چطور محصول مناسب فضای خودم را انتخاب کنم؟",
            answer:
              "برای انتخاب بهتر، می‌توانید ابعاد فضا، نوع کاربری و سبک طراحی موردنظر خود را در نظر بگیرید. همچنین با استفاده از تصاویر، مشخصات محصول و قابلیت مشاهده در فضای واقعی، تصمیم‌گیری دقیق‌تری خواهید داشت.",
          },
          {
            id: "item-3",
            question: "چطور محصول مناسب فضای خودم را انتخاب کنم؟",
            answer:
              "برای انتخاب بهتر، می‌توانید ابعاد فضا، نوع کاربری و سبک طراحی موردنظر خود را در نظر بگیرید. همچنین با استفاده از تصاویر، مشخصات محصول و قابلیت مشاهده در فضای واقعی، تصمیم‌گیری دقیق‌تری خواهید داشت.",
          },
          {
            id: "item-4",
            question: "چطور محصول مناسب فضای خودم را انتخاب کنم؟",
            answer:
              "برای انتخاب بهتر، می‌توانید ابعاد فضا، نوع کاربری و سبک طراحی موردنظر خود را در نظر بگیرید. همچنین با استفاده از تصاویر، مشخصات محصول و قابلیت مشاهده در فضای واقعی، تصمیم‌گیری دقیق‌تری خواهید داشت.",
          },
        ];

  if (!interactive) {
    return (
      <section>
        <dl className="space-y-4">
          {faqData.map((item) => (
            <div key={item.id} className="border-none">
              <dt className="group glass-box !flex-row rounded-2xl text-sm lg:text-base flex justify-start gap-4 px-10 font-semibold">
                <AccordionIcons />
                <span>{item.question}</span>
              </dt>
              <dd className={`px-10 mt-5 ${faqAnswerClassName}`}>
                <div dangerouslySetInnerHTML={{ __html: item.answer }} />
              </dd>
            </div>
          ))}
        </dl>
      </section>
    );
  }

  return (
    <section>
      <Accordion type="single" collapsible className="space-y-4">
        {faqData.map((item) => (
          <AccordionItem key={item.id} value={item.id} className="border-none">
            <AccordionTrigger className="group glass-box !flex-row rounded-2xl text-sm lg:text-base flex justify-start gap-4 hover:no-underline px-10 font-semibold [&>svg]:hidden transition-all">
              <AccordionIcons />
              <span>{item.question}</span>
            </AccordionTrigger>

            <AccordionContent className={`px-10 mt-5 ${faqAnswerClassName}`}>
              <div dangerouslySetInnerHTML={{ __html: item.answer }} />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}

export { faqAnswerClassName };
